export default __webpack_public_path__ + "819b42de5282f9d155eb30d561f182ff.png";